import { atom } from 'jotai';

export const matrixReadyAtom = atom<boolean>(false);
